module.exports = __webpack_public_path__ + "static/media/anonymousBlackSmall.6bb5c35d.svg";